import { createTheme } from "@mui/material";
import 'styles/palette.css';

const LightTheme = createTheme({
    palette: {
        primary: {
            main: "#1976d2",
        },
        secondary: {
            main: "#4b5563",
        },
        background: {
            default: "#f5f7fa",
        },
        text: {
            primary: "#1f2937",
            secondary: "#4b5563"
        }
    },
    components: {
        MuiMenuItem: {
            styleOverrides: {
                root: {
                    backgroundColor: "#ffffff",
                    "&.Mui-selected": {
                        backgroundColor: "#e3f2fd",
                        "&:hover": {
                            background: "#bbdefb",
                        }
                    },
                    "&:hover": {
                        background: "#f5f5f5",
                    }
                }
            }
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    background: "#ffffff",
                }
            }
        },
        MuiPickersDay: {
            styleOverrides: {
                root: {
                    background: "#ffffff"
                }
            }
        },
        MuiSvgIcon: {
            styleOverrides: {
                root: {
                    color: "#4b5563"
                }
            }
        }
    } as any
});

export default LightTheme;
